import { render, staticRenderFns } from "./payTransfer.vue?vue&type=template&id=803129fc"
import script from "./payTransfer.vue?vue&type=script&lang=js"
export * from "./payTransfer.vue?vue&type=script&lang=js"
import style0 from "./payTransfer.vue?vue&type=style&index=0&id=803129fc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports